/**
 * <featured-collection> — optional aria sync when multiple carousel blocks exist.
 * Scrollbar markup stays in `.pc__carousels` below the cards (not moved in DOM).
 */
import '@theme/drag-cursor';

class FeaturedCollection extends HTMLElement {
  #initialized = false;
  #observer = null;

  connectedCallback() {
    if (this.#initialized) return;
    this.#initialized = true;

    this.#syncScrollbarVisibility();

    const blocks = this.querySelectorAll('.featured-collection__block');
    if (blocks.length > 1) {
      this.#observer = new MutationObserver(() => this.#syncScrollbarVisibility());
      blocks.forEach((block) => {
        this.#observer.observe(block, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
        });
      });
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
    this.#initialized = false;
  }

  #syncScrollbarVisibility() {
    const blocks = this.querySelectorAll('.featured-collection__block');
    const scrollbars = this.querySelectorAll('.featured-collection__swiper-scrollbar');

    if (!scrollbars.length) return;

    const activeBlock =
      Array.from(blocks).find((block) => block.getAttribute('aria-hidden') !== 'true') ||
      blocks[0];
    const activeId = activeBlock?.getAttribute('data-block-id');

    if (!activeId) return;

    scrollbars.forEach((scrollbar) => {
      const isMatch = scrollbar.getAttribute('data-block-id') === activeId;
      if (isMatch) {
        scrollbar.removeAttribute('aria-hidden');
      } else {
        scrollbar.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('featured-collection')) {
  customElements.define('featured-collection', FeaturedCollection);
}
